import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaInstagram, FaWhatsapp, FaGoogle } from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  const location = useLocation();

  const scrollToSection = (sectionId) => {
    // If we're not on the home page, navigate there first
    if (location.pathname !== '/') {
      window.location.href = `/#${sectionId}`;
      return;
    }

    const element = document.getElementById(sectionId);
    if (element) {
      const headerOffset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
    }
  };

  const handleHomeClick = (e) => {
    if (location.pathname !== '/') {
      e.preventDefault();
      window.location.href = '/';
    } else {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <motion.div
            className="footer-brand"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <div className="footer-logo">
              <img src="/Handmade haven.png" alt="Handmade Haven Logo" className="footer-logo-image" loading="lazy" />
            </div>
            <p>Handcrafted with love and magic. Every piece tells a story.</p>
            <p className="footer-location-text">Resin Art Store in Ahmedabad | Gujarat | India</p>
          </motion.div>

          <motion.div
            className="footer-links"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
          >
            <h4>Quick Links</h4>
            <ul>
              <li><a href="/" onClick={handleHomeClick}>Home</a></li>
              <li><a href="#about" onClick={(e) => { e.preventDefault(); scrollToSection('about'); }}>About</a></li>
              <li><a href="#products" onClick={(e) => { e.preventDefault(); scrollToSection('products'); }}>Products</a></li>
              <li><a href="#gallery" onClick={(e) => { e.preventDefault(); scrollToSection('gallery'); }}>Gallery</a></li>
              <li><a href="#contact" onClick={(e) => { e.preventDefault(); scrollToSection('contact'); }}>Contact</a></li>
            </ul>
          </motion.div>

          <motion.div
            className="footer-social"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <h4>Connect With Us</h4>
            <div className="footer-social-icons">
              <motion.a
                href="https://www.instagram.com/_handmade.haven_"
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon"
                whileHover={{ scale: 1.2, y: -5 }}
                whileTap={{ scale: 0.9 }}
              >
                <FaInstagram />
              </motion.a>
              <motion.a
                href="https://wa.me/917622073006"
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon"
                whileHover={{ scale: 1.2, y: -5 }}
                whileTap={{ scale: 0.9 }}
              >
                <FaWhatsapp />
              </motion.a>
              <motion.a
                href="https://share.google/tZTJAylCh12AqC0Xs"
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon"
                whileHover={{ scale: 1.2, y: -5 }}
                whileTap={{ scale: 0.9 }}
              >
                <FaGoogle />
              </motion.a>
            </div>
          </motion.div>
        </div>
        <div className="footer-policies">
          <Link to="/privacy-policy" className="footer-policy-link">
            Privacy Policy
          </Link>
          <span className="footer-policy-separator">|</span>
          <Link to="/terms-and-conditions" className="footer-policy-link">
            Terms &amp; Conditions
          </Link>
          <span className="footer-policy-separator">|</span>
          <Link to="/refund-and-returns" className="footer-policy-link">
            Refund and Returns Policy
          </Link>
          <span className="footer-policy-separator">|</span>
          <Link to="/shipping-policy" className="footer-policy-link">
            Shipping Policy
          </Link>
        </div>
        <div className="footer-bottom">
          <p>&copy; Handmade Haven™ Crafted by Muskan Kazi</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

